export default __webpack_public_path__ + "static/media/mbe-logo.80430c33.svg";